import React from "react"
import { Link } from "gatsby"
import { HeroContainer, Wrapper, Overlay, Content } from "./styles"

const Hero = ({ item }) => {
  let heroStyle = {}
  if (item.customFields.backgroundImage) {
    heroStyle.backgroundImage = `url(${item.customFields.backgroundImage.url})`
  }
  return (
    <HeroContainer style={heroStyle}>
      <Overlay>
        <Wrapper>
          <Content>
            <h1>{item.customFields.title}</h1>
            <p>{item.customFields.subtitle}</p>
            <Link to={item.customFields.link.href}>
              {item.customFields.link.text}
            </Link>
          </Content>
        </Wrapper>
      </Overlay>
    </HeroContainer>
  )
}

export default Hero
